var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUseCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13953 0C7.46107 0 6.8104 0.269518 6.33066 0.749262C5.85091 1.22901 5.5814 1.87968 5.5814 2.55814V3.72093H2.55814C1.14532 3.72093 0 4.86625 0 6.27907V15.5814C0 16.9942 1.14532 18.1395 2.55814 18.1395H17.4419C18.8547 18.1395 20 16.9942 20 15.5814V6.27907C20 4.86625 18.8547 3.72093 17.4419 3.72093H14.4186V2.55814C14.4186 1.87968 14.1491 1.22901 13.6693 0.749262C13.1896 0.269518 12.5389 0 11.8605 0H8.13953ZM13.0233 3.72093V2.55814C13.0233 2.24975 12.9007 1.95399 12.6827 1.73592C12.4646 1.51786 12.1689 1.39535 11.8605 1.39535H8.13953C7.83114 1.39535 7.53538 1.51786 7.31732 1.73592C7.09925 1.95399 6.97674 2.24975 6.97674 2.55814V3.72093H13.0233ZM6.97674 5.11628H13.0233V16.7442H6.97674V5.11628ZM5.5814 5.11628H2.55814C1.91595 5.11628 1.39535 5.63688 1.39535 6.27907V15.5814C1.39535 16.2236 1.91595 16.7442 2.55814 16.7442H5.5814V5.11628ZM14.4186 16.7442V5.11628H17.4419C18.0841 5.11628 18.6047 5.63688 18.6047 6.27907V15.5814C18.6047 16.2236 18.0841 16.7442 17.4419 16.7442H14.4186Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUseCases);
export default __webpack_public_path__ + "static/media/icon-use-cases.dc408cfa3e05a016cd4d7bccb3d3df9e.svg";
export { ForwardRef as ReactComponent };